import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const ReviewNoDataIcon: FunctionalComponent<IIconProps> = ({ width = '16', height = '16' }) => {
  // @ts-ignore
  return (
    /*@ts-ignore*/
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 161 160">
      {/*@ts-ignore*/}
      <g clip-path="url(#review-no-data)">
        <path
          fill="#FAFAFA"
          d="M80.493 159.985c44.178 0 79.992-35.814 79.992-79.992C160.485 35.813 124.671 0 80.493 0 36.313 0 .5 35.814.5 79.993c0 44.178 35.814 79.992 79.993 79.992z"
        />
        <path
          fill="#FFF9E7"
          fill-rule="evenodd"
          stroke="#CCC"
          stroke-width="3"
          d="M72.874 86.74c-1.213.635-2.707.162-3.343-1.036-.252-.474-.34-1.021-.252-1.554l1.243-7.16-5.252-5.075c-.977-.947-1.006-2.5-.045-3.476.37-.385.858-.636 1.406-.725l7.264-1.05 3.255-6.525c.606-1.213 2.1-1.716 3.328-1.11.489.237.888.637 1.125 1.11l3.254 6.524 7.264 1.05c1.361.193 2.293 1.436 2.101 2.782-.074.533-.325 1.036-.725 1.405l-5.252 5.075 1.243 7.16c.237 1.332-.68 2.604-2.027 2.84-.532.09-1.095 0-1.568-.25l-6.495-3.388-6.524 3.402z"
          clip-rule="evenodd"
        />
        <path
          fill="#FFF9E7"
          fill-rule="evenodd"
          stroke="#CCC"
          stroke-width="2.5"
          d="M105.599 81.176c-.725.385-1.627.104-1.997-.621-.148-.281-.207-.622-.148-.932l.74-4.29-3.152-3.033c-.591-.563-.591-1.495-.029-2.072.222-.236.532-.384.843-.429l4.35-.62 1.938-3.907c.369-.725 1.257-1.02 1.982-.665.296.148.533.384.681.665l1.938 3.906 4.349.621c.814.119 1.376.858 1.258 1.672-.045.326-.193.621-.429.843l-3.152 3.033.74 4.29c.133.8-.399 1.554-1.213 1.702-.325.06-.651 0-.947-.148l-3.891-2.027-3.861 2.012zM45.357 81.176c-.725.385-1.628.104-1.998-.621-.147-.281-.207-.622-.147-.932l.74-4.29L40.8 72.3c-.592-.563-.592-1.495-.03-2.072.222-.236.533-.384.844-.429l4.35-.62 1.937-3.907c.37-.725 1.258-1.02 1.983-.665.296.148.532.384.68.665l1.938 3.906 4.35.621c.814.119 1.376.858 1.257 1.672-.044.326-.192.621-.429.843l-3.15 3.033.739 4.29c.133.8-.4 1.554-1.213 1.702-.326.06-.651 0-.947-.148l-3.89-2.027-3.862 2.012z"
          clip-rule="evenodd"
        />
        <path
          stroke="#CCC"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="4"
          d="M121.843 104.196H70.211l-22.872 15.327v-15.327h-9.853c-3.27 0-5.918-2.648-5.918-5.917V47.342c0-3.27 2.649-5.918 5.918-5.918h84.357c3.27 0 5.918 2.648 5.918 5.918v50.937c0 3.269-2.648 5.917-5.918 5.917z"
        />
      </g>
      {/*@ts-ignore*/}
      <defs>
        {/*@ts-ignore*/}
        <clipPath id="review-no-data">
          <path fill="#fff" d="M0 0H160V160H0z" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ReviewNoDataIcon;
